import { convertToTitleCase } from "../../utils/helpers";

const STATUS_COLORS = {
  pending: "#ff9500",
  pending_payment: "#ff9500",
  submitted: "#ff9500",
  under_review: "#0556e5",
  approved: "#19bc31",
  verified: "#19bc31",
  allocated: "#31778c",
  matured: "#19bc31",
  declined: "#ff4343",
  cancelled: "#a1a0a0",
  rejected: "#ff4343",
  failed: "#ff4343",
  none: "#a1a0a0",
  active: "#19bc31",
  in_stock: "#19bc31",
  low_stock: "#ff9500",
  out_of_stock: "#ff4343",
  preorder: "#31778c",
  pre_order: "#31778c",
};

export default function InvestorStatusBadge({ status, label, className = "", backgroundColor }) {
  const key = String(status || "none").toLowerCase().replace(/\s+/g, "_");
  const bg = backgroundColor || STATUS_COLORS[key] || "#a1a0a0";
  const text = label || convertToTitleCase(status);

  return (
    <span
      className={`badge rounded-pill text-white ${className}`}
      style={{ background: bg, fontSize: 11, fontWeight: 600, minWidth: 72, padding: "0.35em 0.75em" }}
    >
      {text}
    </span>
  );
}
